module.exports = __webpack_public_path__ + "img/C9-brazil.b06748a1.png";